import { useState } from 'react';
import { useMapEvents } from 'react-leaflet';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import { makeStyles } from '@mui/styles';

import { LegendItems } from '../../../constants/Constants';

const useStyles = makeStyles(() => ({
  legendContainer: {
    position: 'absolute',
    bottom: '20px',
    left: '10px',
    padding: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '4px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
    fontSize: '12px',
    zIndex: 1000,
    width: '200px',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  },
  coloredLine: {
    width: '30px',
    height: '5px',
    marginRight: '5px',
  },
  yellowDot: {
    width: '15px',
    height: '15px',
    backgroundColor: 'yellow',
    borderRadius: '50%',
    marginLeft: '6px',
    marginRight: '12px',
  },
}));

const MapLegend = () => {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);

  useMapEvents({
    mousemove() {
      setIsHovered(true);
    },
    mouseout() {
      setIsHovered(false);
    },
  });

  return (
    <>
      {isHovered && (
        <div className={classes.legendContainer}>
          <div className={classes.legendItem}>
            <div className={classes.coloredLine} style={{ backgroundColor: 'purple' }} />
            <span>{LegendItems.geofence}</span>
          </div>

          <div className={classes.legendItem}>
            <div className={classes.coloredLine} style={{ backgroundColor: 'green' }} />
            <span>{LegendItems.estimatedReaderRadius}</span>
          </div>

          <div className={classes.legendItem}>
            <LocationOnIcon style={{ color: '#2A81CA', marginLeft: '4px', marginRight: '8px' }} />
            <span>{LegendItems.lockedLocationReader}</span>
          </div>

          <div className={classes.legendItem}>
            <div className={classes.yellowDot} />
            <span>{LegendItems.recentReportLocation}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default MapLegend;
